import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1dfebd8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"text-align":"left","color":"blue"} }
const _hoisted_2 = { style: {"font-size":"13px","color":"#fb2a2a","text-align":"left","margin-left":"5px"} }
const _hoisted_3 = ["model"]
const _hoisted_4 = { class: "wrap_header" }
const _hoisted_5 = { class: "menubar" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-send",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Gởi kết quả CLS")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-dollar",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Nhân viên nhận thông báo CK")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-money-bill",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Danh sách HĐ")
const _hoisted_12 = { class: "logouts" }
const _hoisted_13 = {
  key: 1,
  id: "fotter"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wrap_header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "coppyi" }, "© Copyright 2025 - Bệnh viện Phổi Đà Nẵng")
], -1))
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, _toDisplayString($setup.currentTime.toLocaleTimeString('en-GB')) + " " + _toDisplayString($setup.currentTime.toLocaleDateString('en-GB')), 1)
    ]),
    ($props.isLoggedIn)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: "header",
          model: $setup.appMenu
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createVNode(_component_RouterLink, { to: "/sendfile" }, {
                    default: _withCtx(() => [
                      _hoisted_6,
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_RouterLink, { to: "/addAccountantPage" }, {
                    default: _withCtx(() => [
                      _hoisted_8,
                      _hoisted_9
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_RouterLink, { to: "/showListInvoice" }, {
                    default: _withCtx(() => [
                      _hoisted_10,
                      _hoisted_11
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_Button, {
                label: "Đăng xuất",
                onClick: $setup.logout,
                icon: "pi pi-sign-out",
                iconPos: "right",
                class: "p-button-secondary"
              }, null, 8, ["onClick"])
            ])
          ])
        ], 8, _hoisted_3))
      : _createCommentVNode("", true),
    ($props.isLoggedIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
      : _createCommentVNode("", true)
  ], 64))
}